import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import SelectAsync from 'react-select/async';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, Badge } from "reactstrap";


export default class ConfigCompany extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'settingco',
            id: props.Id,
            data: null,
            id_to_remove: null,
            loading: true
        }
    }
    toggle = () => this.setState({ modal: !this.state.modal });
    componentDidMount() {
        this.httpPost("api/v1/settingco/getconfig", {
            id: 0
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    loadType(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/settingco/getlookuptype/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    removeAccount() {
        this.httpPost("/api/v1/settingco/remove/", {
            id: this.state.id_to_remove
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
                    this.state.id_to_remove = null;
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    getQuestion() {
        return [
            <div className="modal fade" tabindex="-1" id="modalConfirmRemove2" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                                <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                                <h4 className="nk-modal-title">هشدار حذف اطلاعات</h4>
                                <div className="nk-modal-text">
                                    <p className="lead">آیا از حذف آیتم انتخابی مطمئن هستید؟</p>
                                    <p className="text-soft">توجه داشته باشید که در صورت حذف اطلاعات دیگر امکان بازیابی اطلاعات وجود ندارد</p>
                                </div>
                                <div className="nk-modal-action mt-5">
                                    <a className="btn btn-lg btn-mw btn-danger hand" data-bs-dismiss="modal" onClick={e => { this.removeAccount(); }} style={{ "margin-left": "25px" }}>بله - حذف شود</a>
                                    <a className="btn btn-lg btn-mw btn-light hand" data-bs-dismiss="modal" onClick={e => { this.setState({ id_to_remove: null }); }}>خیر - برگشت</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ];
    }
    BasedContract(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/settingco/getaccountbasedcontract/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    AccountItemTax(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/settingco/getaccountitemtax/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    AccountUnit(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/settingco/getaccountunit/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    AccountBasisCalculation(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/settingco/getaccountbasiscalculation/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    AccountTotalCode(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/settingco/getaccounttotalcode/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    AccountGivenCode(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/settingco/getaccountgivencode/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };




    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/settingco/saveaccount", {
            id: this.state.data.newrecord.id,
            accountTitle: this.state.data.newrecord.accountTitle,
            accountContinuous: this.state.data.newrecord.accountContinuous,
            accountCash: this.state.data.newrecord.accountCash,
            accountTaxable: this.state.data.newrecord.accountTaxable,
            accountCoveredInsurance: this.state.data.newrecord.accountCoveredInsurance,
            accountType: this.state.data.newrecord.accountType,
            accountBasedContract: this.state.data.newrecord.accountBasedContract,
            accountItemTax: this.state.data.newrecord.accountItemTax,
            accountUnit: this.state.data.newrecord.accountUnit,
            accountBasisCalculation: this.state.data.newrecord.accountBasisCalculation,
            accountGreatRate: this.state.data.newrecord.accountGreatRate,
            accountTotalCode: this.state.data.newrecord.accountTotalCode,
            accountGivenCode: this.state.data.newrecord.accountGivenCode,



        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        data: data,
                        loading: false, modal: !this.state.modal
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    GetAccount(id) {
        this.httpPost("api/v1/settingco/getconfigedit", {
            id: id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {

                    this.setState({
                        data: data,
                        loading: false, modal: !this.state.modal
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    DeleteAccount(id) {
        this.httpPost("api/v1/settingco/getconfigedit", {
            id: id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {

                    this.setState({
                        data: data,
                        loading: false, modal: !this.state.modal
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }


    changeType(type) {
        this.state.data.record.type = type;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="container-fluid">
            <div className="nk-content-inner">
                <div className="nk-content-body">
                    <div className="components-preview wide-md mx-auto">
                        <div className="nk-block-head nk-block-head-lg wide-sm">
                            <div className="nk-block-head-content">
                                <div className="nk-block-head-sub">
                                    <NavLink className="back-to" to="/home/"><em className="icon ni ni-arrow-left"></em><span>داشبورد</span></NavLink>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-aside-wrap">
                                        <div className="card-inner card-inner-lg">
                                            <div className="nk-block-head nk-block-head-lg">
                                                <div className="nk-block-between">
                                                    <div className="nk-block-head-content">

                                                        <span>این تنظیمات به شما کمک می کند تنظیمات مزایای شرکت را تغییر دهید.</span>
                                                        <br />
                                                        <br />
                                                        <button className="btn btn-outline-success" type="button" onClick={e => this.setState({

                                                            modal: !this.state.modal,

                                                        })}>افزودن مزایا</button>
                                                    </div>

                                                    <div className="nk-block-head-content align-self-start d-lg-none">
                                                        <a href="#" className="toggle btn btn-icon btn-trigger mt-n1" data-target="userAside"><em className="icon ni ni-menu-alt-r"></em></a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="nk-block">
                                                <div class="card-inner-group">
                                                    {this.state.data.record.map((record, index) =>
                                                        <div class="card-inner border border-gray bg-lighter text-dark">
                                                            <div class="nk-block-text bg-gray-600 text-white">

                                                                <button className="btn-round btn " onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove2">
                                                                    <em class="icon ni ni-cross-round-fill text-white"></em>
                                                                </button>
                                                                <button className="btn-round btn" onClick={e => this.GetAccount(record.id)}>
                                                                    <em class="icon ni ni-pen text-white"></em>
                                                                </button>
                                                            </div>
                                                            <br />
                                                            <div className="row">
                                                                <h6 className="text-center">{record.accountTitle}</h6>
                                                            </div>
                                                            <br />
                                                            <div class="between-center flex-wrap g-3">



                                                                <div className="col-3 border">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">نوع</label>
                                                                        <div className="form-control-wrap">

                                                                            <label className="form-label">{record.typeTitle}</label>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 border">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">مبنا</label>
                                                                        <div className="form-control-wrap">

                                                                            <label className="form-label">{record.baseContractTitle}</label>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 border">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">مستمر</label>
                                                                        <div className="form-control-wrap">
                                                                            {record.accountContinuous === true ? (
                                                                                <em class="icon ni ni-done text-success"></em>
                                                                            ) :
                                                                                (
                                                                                    <em class="icon ni ni-done text-danger"></em>
                                                                                )

                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 border">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">نقدی</label>
                                                                        <div className="form-control-wrap">
                                                                            {record.accountCash === true ? (
                                                                                <em class="icon ni ni-done text-success"></em>
                                                                            ) :
                                                                                (
                                                                                    <em class="icon ni ni-done text-danger"></em>
                                                                                )

                                                                            }

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 border">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">مشمول مالیات</label>
                                                                        <div className="form-control-wrap">
                                                                            {record.accountTaxable === true ? (
                                                                                <em class="icon ni ni-done text-success"></em>
                                                                            ) :
                                                                                (
                                                                                    <em class="icon ni ni-done text-danger"></em>
                                                                                )

                                                                            }

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 border">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">مشمول بیمه</label>
                                                                        <div className="form-control-wrap">
                                                                            {record.accountCoveredInsurance === true ? (
                                                                                <em class="icon ni ni-done text-success"></em>
                                                                            ) :
                                                                                (
                                                                                    <em class="icon ni ni-done text-danger"></em>
                                                                                )

                                                                            }

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 border">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">آیتم مالیات</label>
                                                                        <div className="form-control-wrap">

                                                                            <label className="form-label">{record.itemTaxTitle}</label>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 border">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">واحد ریال</label>
                                                                        <div className="form-control-wrap">

                                                                            <label className="form-label">{record.unitTitle}</label>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 border">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">مبنای محاسبه</label>
                                                                        <div className="form-control-wrap">
                                                                            <label className="form-label">{record.accountBasisCalculationStr}</label>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 border">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">نرخ فوق العاده</label>
                                                                        <div className="form-control-wrap">
                                                                            <label className="form-label">{record.accountGreatRate}</label>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 border">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">کد حساب کل</label>
                                                                        <div className="form-control-wrap">
                                                                            <label className="form-label">{record.totalCodeTitle}</label>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 border">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">کد حساب معین</label>
                                                                        <div className="form-control-wrap">
                                                                            <label className="form-label">{record.givenCodeTitle}</label>


                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>



                                                        </div>

                                                    )}

                                                </div>
                                            </div>

                                        </div>

                                        <div class="card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg toggle-screen-lg" data-toggle-body="true" data-content="userAside" data-toggle-screen="lg" data-toggle-overlay="true" style={{ backgroundColor: "#16498a"} }>
                                            <div class="card-inner-group" data-simplebar="init">
                                                <div class="simplebar-wrapper" style={{ margin: '0px' }} >
                                                    <div class="simplebar-height-auto-observer-wrapper">
                                                        <div class="simplebar-height-auto-observer"></div>
                                                    </div>
                                                    <div class="simplebar-mask">
                                                        <div class="simplebar-offset" style={{ left: '0px', bottom: '0px' }} >
                                                            <div class="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content" style={{ height: 'auto', overflow: 'hidden' }} >
                                                                <div class="simplebar-content" style={{ padding: '0px' }} >
                                                                    <div class="card-inner">
                                                                        <h3 class="nk-block-title page-title text-white">تنظیمات</h3>
                                                                        <div class="nk-block-des text-soft text-white">
                                                                            <p className="text-white">در این قسمت مزایای شرکت خود را تعریف میکنید</p>
                                                                        </div>
                                                                    </div>

                                                                    <div class="card-inner p-0">
                                                                        <ul class="link-list-menu">
                                                                            <li style={{ boxShadow: "0 0 25px -12px rgba(31, 43, 58, 0.15)", backgroundColor:"#fff" }}>
                                                                                <a class="active"  href="/ConfigCompany"><em class="icon ni ni-user-fill-c"></em><span>مزایا</span></a>
                                                                            </li>
                                                                            <li>
                                                                                <a href="/ConfigTax" className="text-white"><em class="icon ni ni-lock-alt-fill text-white"></em><span>جدول مالیات</span></a>
                                                                            </li>
                                                                            <li>
                                                                                <a href="/FixedAmount" className="text-white"><em class="icon ni ni-shield-star-fill text-white"></em><span>مبلغ ثابت جهت قرارداد</span></a>
                                                                            </li>
                                                                            <li>
                                                                                <a href="/InsuranceTaxSettings" className="text-white"><em class="icon ni ni-activity-round-fill text-white"></em><span>سایر تنظیمات بیمه و مالیات</span></a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="simplebar-placeholder" style={{ width: 'auto', height: '376px' }} >
                                                    </div>
                                                </div>
                                                <div class="simplebar-track simplebar-horizontal" style={{ visibility: 'hidden' }} >
                                                    <div class="simplebar-scrollbar" style={{ width: '0px', display: 'none' }} >
                                                    </div>
                                                </div>
                                                <div class="simplebar-track simplebar-vertical" style={{ visibility: 'hidden' }} >
                                                    <div class="simplebar-scrollbar" style={{ height: '0px', display: 'none' }} >
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>
            </div>

            <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg" >
                <ModalHeader
                    toggle={this.toggle}
                    close={
                        <Button className="close" onClick={this.toggle}>
                            بستن
                        </Button>
                    }
                >
                    <h3>{this.state.lableholder}</h3>
                </ModalHeader>
                <ModalBody>
                    <div className="nk-block nk-block-lg">
                        <div className="card card-bordered">
                            <div className="card-inner">
                                <div className="card-head">

                                </div>
                                <div className="card-body">
                                    <form method="post" onSubmit={e => this.save(e)} novalidate="novalidate">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">عنوان </label>
                                                    <div className="form-control-wrap">
                                                        <input className="form-control" type="text" defaultValue={this.state.data.newrecord.accountTitle} onChange={e => this.state.data.newrecord.accountTitle = e.target.value} required />

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row g-4">

                                            <div className="col-lg-3">

                                                <div class="custom-control custom-checkbox">
                                                    <input defaultChecked={this.state.data.newrecord.accountContinuous} onChange={e => this.state.data.newrecord.accountContinuous = e.target.checked} type="checkbox" class="custom-control-input" id="customCheck1" />
                                                    <label class="custom-control-label" for="customCheck1">مستمر</label>

                                                </div>
                                            </div>
                                            <div className="col-lg-3">
                                                <div class="custom-control custom-checkbox">

                                                    <input defaultChecked={this.state.data.newrecord.accountCash} onChange={e => this.state.data.newrecord.accountCash = e.target.checked} type="checkbox" class="custom-control-input" id="customCheck2" />
                                                    <label class="custom-control-label" for="customCheck2">نقدی</label>

                                                </div>
                                            </div>
                                            <div className="col-lg-3">
                                                <div class="custom-control custom-checkbox">

                                                    <input defaultChecked={this.state.data.newrecord.accountTaxable} onChange={e => this.state.data.newrecord.accountTaxable = e.target.checked} type="checkbox" class="custom-control-input" id="customCheck3" />
                                                    <label class="custom-control-label" for="customCheck3">مشمول مالیات</label>

                                                </div>
                                            </div>
                                            <div className="col-lg-3">
                                                <div class="custom-control custom-checkbox">

                                                    <input defaultChecked={this.state.data.newrecord.accountCoveredInsurance} onChange={e => this.state.data.newrecord.accountCoveredInsurance = e.target.checked} type="checkbox" class="custom-control-input" id="customCheck4" />
                                                    <label class="custom-control-label" for="customCheck4">مشمول بیمه</label>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row g-2">

                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">نوع </label>
                                                    <div className="form-control-wrap">
                                                        <SelectAsync
                                                            defaultValue={this.state.data.newrecord.accountType > 0 ? [{ value: this.state.data.newrecord.accountType, label: this.state.data.newrecord.accountTypeText }] : null}
                                                            isMulti={false}
                                                            placeholder="نوع"
                                                            defaultOptions
                                                            isSearchable
                                                            loadOptions={this.loadType}
                                                            onChange={e => this.state.data.newrecord.accountType = e.value}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">مبنای قرارداد </label>
                                                    <div className="form-control-wrap">
                                                        <SelectAsync
                                                            defaultValue={this.state.data.newrecord.accountBasedContract > 0 ? [{ value: this.state.data.newrecord.accountBasedContract, label: this.state.data.newrecord.accountBasedContractText }] : null}
                                                            isMulti={false}
                                                            placeholder="مبنای قرارداد"
                                                            defaultOptions
                                                            isSearchable
                                                            loadOptions={this.BasedContract}
                                                            onChange={e => this.state.data.newrecord.accountBasedContract = e.value}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row g-2">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">آیتم مالیات </label>
                                                    <div className="form-control-wrap">
                                                        <SelectAsync
                                                            defaultValue={this.state.data.newrecord.accountItemTax > 0 ? [{ value: this.state.data.newrecord.accountItemTax, label: this.state.data.newrecord.accountItemTaxText }] : null}
                                                            isMulti={false}
                                                            placeholder="آیتم مالیات"
                                                            defaultOptions
                                                            isSearchable
                                                            loadOptions={this.AccountItemTax}
                                                            onChange={e => this.state.data.newrecord.accountItemTax = e.value}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">واحد ریال </label>
                                                    <div className="form-control-wrap">
                                                        <SelectAsync
                                                            defaultValue={this.state.data.newrecord.accountUnit > 0 ? [{ value: this.state.data.newrecord.accountUnit, label: this.state.data.newrecord.accountUnitText }] : null}
                                                            isMulti={false}
                                                            placeholder="واحد ریال"
                                                            defaultOptions
                                                            isSearchable
                                                            loadOptions={this.AccountUnit}
                                                            onChange={e => this.state.data.newrecord.accountUnit = e.value}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row g-2">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">مبنای محاسبه </label>
                                                    <div className="form-control-wrap">
                                                        <SelectAsync
                                                            defaultValue={this.state.data.newrecord.accountBasisCalculation > 0 ? [{ value: this.state.data.newrecord.accountBasisCalculation, label: this.state.data.newrecord.accountBasisCalculationText }] : null}
                                                            isMulti={false}
                                                            placeholder="مبنای محاسبه"
                                                            defaultOptions
                                                            isSearchable
                                                            loadOptions={this.AccountBasisCalculation}
                                                            onChange={e => this.state.data.newrecord.accountBasisCalculation = e.value}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">نرخ فوق العاده %</label>
                                                    <div className="form-control-wrap">
                                                        <input className="form-control" type="text" defaultValue={this.state.data.newrecord.accountGreatRate} onChange={e => this.state.data.newrecord.accountGreatRate = e.target.value} />

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row g-2">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">کد حساب کل </label>
                                                    <div className="form-control-wrap">
                                                        <SelectAsync
                                                            defaultValue={this.state.data.newrecord.accountTotalCode > 0 ? [{ value: this.state.data.newrecord.accountTotalCode, label: this.state.data.newrecord.accountTotalCodeText }] : null}
                                                            isMulti={false}
                                                            placeholder="مبنای محاسبه"
                                                            defaultOptions
                                                            isSearchable
                                                            loadOptions={this.AccountTotalCode}
                                                            onChange={e => this.state.data.newrecord.accountTotalCode = e.value}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">کد معین </label>
                                                    <div className="form-control-wrap">
                                                        <SelectAsync
                                                            defaultValue={this.state.data.newrecord.accountGivenCode > 0 ? [{ value: this.state.data.newrecord.accountGivenCode, label: this.state.data.newrecord.accountGivenCodeText }] : null}
                                                            isMulti={false}
                                                            placeholder="مبنای محاسبه"
                                                            defaultOptions
                                                            isSearchable
                                                            loadOptions={this.AccountGivenCode}
                                                            onChange={e => this.state.data.newrecord.accountGivenCode = e.value}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <button type="submit" className="btn btn-lg btn-primary">ثبت مزایا</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </ModalBody>

            </Modal >



        </div >

    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getQuestion(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}